export class Random {

    public getRandomInt(min: number, max: number) : number {
        min = Math.ceil(min);
        max = Math.floor(max);
        
        return Math.floor(Math.random() * (max - min)) + min;
    }

}


// WEBPACK FOOTER //
// /Users/Dan/Documents/PoC/angular-giaa/src/app/shared/randomNumberGenerators.ts